import { OVERLAY_PLACEHOLDER } from './PopupSuspense.config';
import { PopupSuspense as SourcePopupSuspense } from 'SourceComponent/PopupSuspense/PopupSuspense.component';

/** @namespace Component/PopupSuspense/Component */
export class PopupSuspense extends SourcePopupSuspense {

    componentDidMount() {
        const { showOverlay, actualOverlayKey } = this.props;
        if(!actualOverlayKey.length > 0) {
            showOverlay(OVERLAY_PLACEHOLDER);
        }
    }
}

export default PopupSuspense;
